/* eslint-disable */
/* @flow */


//import liraries
import React, { Component } from 'react';
import { View, Text, StyleSheet, TextInput } from 'react-native';

import Cell from './Cell'

import styles from './Styles/TextAreaCellStyles'

// create a component
class TextAreaCell extends Component {

    render() {
        const {
            meta: { touched, error, warning }, input: { value, onBlur, onChange, ...restInput },
            autoCapitalize,
            autoCorrect,
            keyboardType = 'default',
            placeholder,
            secure,
            separator,
            title,
           height 

        } = this.props
        return (
            <Cell separator={separator}>
                <View style={styles.container}>
                    <Text style={styles.title}>{title}</Text>
                    <TextInput
                    onBlur = {onBlur}
                        {...restInput}
                        autoCorrect={autoCorrect}
                        multiline = {true}
                        numberOfLines = {10}
                        onChangeText={onChange}
                        placeholder={placeholder}
                        
                        style={[styles.textInput]}
                        value={value}
                    />
                </View>
                {touched && ((error && <Text style={styles.error}>{error}</Text>) ||
                    (warning && <Text style={styles.warning}>{warning}</Text>))}
            </Cell>
        );
    }
}

export default TextAreaCell
